import React, { useState } from "react";
import { FormattedMessage } from "react-intl";
import { SnackbarContentWrapper } from ".";

import GetAppIcon from "@material-ui/icons/GetApp";
import BlockIcon from "@material-ui/icons/Block";
import { useSnackbar } from "notistack";
import { CircularProgress } from "@material-ui/core";
import { navigate } from "@reach/router";

interface DownloadDocumentButtonProps {
	endpoint: string;
	filename?: string;
}

export const DownloadDocumentButton = (props: DownloadDocumentButtonProps) => {
	const { endpoint, filename } = props;
	const [loading, setLoading] = useState(false);
	const [responseCode, setResponseCode] = useState(-1);
	const { enqueueSnackbar } = useSnackbar();

	return (
		<div style={{ width: "100%", textAlign: "center" }}>
			{loading ? (
				<CircularProgress size={30} />
			) : responseCode === -1 || responseCode === 200 ? (
				<GetAppIcon
					style={{ cursor: "pointer" }}
					onClick={() =>
						downloadDocument({
							setLoading: setLoading,
							setResponseCode: setResponseCode,
							enqueueSnackbar: enqueueSnackbar,
							filename: filename,
							endpoint: endpoint,
						})
					}
				/>
			) : (
				<BlockIcon />
			)}
		</div>
	);
};

interface DownloadDocumentProps {
	setLoading(loading: boolean): void;
	setResponseCode(response: number): void;
	enqueueSnackbar: any;
	endpoint: string;
	filename?: string;
}

export const downloadDocument = (props: DownloadDocumentProps) => {
	const { setLoading, setResponseCode, enqueueSnackbar, endpoint, filename } =
		props;
	setLoading(true);

	const generalErrorSnackbar = () =>
		enqueueSnackbar("", {
			key: "download-document",
			content: (key: any) => (
				<SnackbarContentWrapper
					variant="error"
					message={
						<FormattedMessage
							id="minside.download_document_button.error_message"
							defaultMessage="Kunne ikke laste ned dokumentet"
							description="Error when download the document"
						/>
					}
					id={key}
				/>
			),
		});

	return fetch(endpoint, {
		method: "GET",
	})
		.then((response) => {
			setResponseCode(response.status);
			const contentDisposition = response.headers.get("Content-Disposition");
			if (response.status === 200) {
				response.blob().then((blob) => {
					let url = window.URL.createObjectURL(blob);
					let a = document.createElement("a");
					a.href = url;
					const filenameMatch = contentDisposition
						? contentDisposition.match(/filename\*?=['"]?([^"';]+)['"]?/i)
						: null;
					if (filename) {
						let fileExt = ".docx";
						if (filenameMatch && filenameMatch[1]) {
							fileExt = filenameMatch[1].endsWith(".pdf") ? ".pdf" : ".docx";
						}
						a.download = filename + fileExt;
					} else if (contentDisposition) {
						if (filenameMatch && filenameMatch[1]) {
							a.download = decodeURIComponent(filenameMatch[1]);
						}
						a.download = "temp.docx";
					}
					a.click();
				});
			} else if (response.status === 401) {
				enqueueSnackbar("", {
					key: "download-document",
					content: (key: any) => (
						<SnackbarContentWrapper
							variant="warning"
							message={
								<FormattedMessage
									id="minside.download_document_button.unauth_message"
									defaultMessage="Sesjonen har utløpt. Vennligst logg inn på nytt"
									description="Session expired"
								/>
							}
							id={key}
						/>
					),
				});
				navigate("/logout", { state: { errorCode: 401 } });
			} else {
				generalErrorSnackbar();
			}
		})
		.finally(() => {
			setLoading(false);
		});
};
